{
  "eyebrow": "Kies je abonnement",
  "title": "Het pakket dat past bij hoe jouw team werkt.",
  "sub": "30 dagen gratis proefperiode op elk abonnement. Geen creditcard nodig. Stop wanneer je wil.",
  "bill": {
    "month": "Maandelijks",
    "year": "Jaarlijks",
    "save": "15% korting"
  },
  "fam": {
    "time": "Tijd & operaties",
    "project": "Project & kostencontrole"
  },
  "compare": "Vergelijk alle functies",
  "compareHide": "Verberg vergelijking",
  "included": "Inbegrepen",
  "select": "Kies {{plan}}",
  "selected": "Geselecteerd",
  "recommended": "Meest gekozen",
  "pricePerMonth": "/ gebruiker / maand",
  "pricePerYear": "/ gebruiker / jaar",
  "base": "basis / maand",
  "admins": "2 beheerders inbegrepen",
  "continueCta": "Doorgaan met {{plan}}",
  "continuePick": "Kies een abonnement om door te gaan",
  "catalogError": "Prijscatalogus niet beschikbaar. Probeer opnieuw om de laatste prijzen te laden.",
  "plans": {
    "timeBasic": "Time Basic",
    "timePro": "Time Pro",
    "projectBasic": "Project Basic",
    "projectPro": "Project Pro",
    "timeBasicBest": "Naleving & eenvoudige registratie",
    "timeProBest": "Teamoperaties",
    "projectBasicBest": "Project- & kostencontrole",
    "projectProBest": "Geavanceerd projectbeheer",
    "feat": {
      "timeBasic": {
        "timeTracking": "Tijdsregistratie",
        "absencesHolidays": "Afwezigheden & verlof",
        "transport": "Vervoersregistratie",
        "workLocations": "Werven & GPS",
        "mobileApp": "Mobiele app voor arbeiders op de werf"
      },
      "timePro": {
        "everythingTime": "Alles uit Time Basic",
        "overtime": "Overurenregistratie",
        "scheduling": "Dienstplanning",
        "documents": "Werknemersdocumenten",
        "officeOps": "Kantoorfuncties (activiteitenlogboek, correcties)",
        "addonsAvailable": "Beschikbare add-ons: projectregistratie, VTT",
        "internalMessaging": "Interne berichten (bedrijfschat)"
      },
      "projectBasic": {
        "everythingTime": "Alles uit Time Basic",
        "projects": "Projecten met kostenbeheersing",
        "extras": "Meerwerk & extra materiaal",
        "subcontractors": "Beheer van onderaannemers",
        "checkInOut": "In- en uitchecken van werknemers",
        "internalMessaging": "Interne berichten (bedrijfschat)"
      },
      "projectPro": {
        "everythingAll": "Alles uit Time Pro + Project Basic",
        "projectTransport": "Projectgebonden vervoer",
        "fullSuite": "Volledige productiviteitssuite",
        "prioritySupport": "Prioritaire ondersteuning",
        "internalMessaging": "Interne berichten (bedrijfschat)"
      }
    },
    "timeZero": "Time Zero"
  },
  "comparison": {
    "title": "Vergelijk alle functies",
    "subtitle": "Alles wat elk abonnement bevat, naast elkaar.",
    "cat": {
      "timeAttendance": "Tijd & aanwezigheid",
      "projectCost": "Project & kostenbeheer",
      "support": "Ondersteuning"
    },
    "val": {
      "upTo4": "Tot 4",
      "unlimited": "Onbeperkt",
      "soon": "Binnenkort",
      "optional": "Optioneel",
      "years5": "5 jaar",
      "years10": "10 jaar"
    },
    "row": {
      "mobileDesktop": "Mobiele & desktop-app",
      "gpsCheckin": "Inchecken met één tik via gps",
      "holidayAbsenceOvertime": "Verlof, afwezigheid & overuren",
      "teamMembers": "Teamleden",
      "workLocations": "Werklocaties",
      "registrationsPerMonth": "Registraties / gebruiker / maand",
      "irregularMap": "Onregelmatig in-/uitchecken op kaart",
      "expenseManagement": "Onkostenbeheer",
      "employeeDocuments": "Werknemersdocumenten",
      "openApi": "Open API",
      "navigation": "Navigatie naar werklocaties",
      "projectManagement": "Projectbeheer (budget)",
      "subprojects": "Subprojecten",
      "subcontractorManagement": "Onderaannemersbeheer",
      "extraWorkMaterials": "Extra werk & materialen",
      "transportProjects": "Transport gekoppeld aan projecten",
      "fullSuite": "Volledige productiviteitssuite",
      "prioritySupport": "Prioriteitsondersteuning",
      "languages12": "Beschikbaar in 12 talen",
      "manualTransport": "Handmatige transportafstand",
      "reportsExcel": "Rapporten & Excel-export",
      "frontendLocations": "Locaties aangemaakt door app-gebruikers",
      "checkInWork": "Check-in/out@work (België)",
      "vehicleTracking": "Vehicle Track & Trace",
      "projectDescriptions": "Projectbeschrijvingen & foto's",
      "dataStorage": "Gegevensopslag",
      "schedulingPlanning": "Planning",
      "messagingNotifications": "Berichten · Meldingen"
    }
  }
}
